module.exports = __webpack_public_path__ + "img/Picto_Step_02.1b0e5ecc.png";